const TemplatesPage = () => import('./TemplatesPage.vue');

const routes = [
  {
    path: '/templates',
    name: 'TemplatesPage',
    id: 'templates',
    component: TemplatesPage,
    linkText: 'navBar.templates',
    meta: { titleExtension: 'navBar.templates' },
    index: 1,
  },
];

export default routes;
